import React from 'react';
import { UserManagement } from '../../components/users/UserManagement';

export const UserManagementPage: React.FC = () => {
  return <UserManagement />;
};
